import React, { FC } from 'react';
import { Image } from 'react-native';

import { Theme } from '@constants';

import { ALERTS_NON_PLATED_ICON_MAP } from '../../../assets/icons/alertsNonPlated/alerts_non_plated_icon_map';
import { ALERTS_NON_PLATED_ICON_PATH_MAP } from '../../../assets/icons/alertsNonPlated/alerts_non_plated_icon_path_map';

export const TWCAlertIcon: FC<TWCAlertIconProps> = ({ eventDescription, height = 50, width = 50 }) => {
  const iconPath = ALERTS_NON_PLATED_ICON_PATH_MAP[ALERTS_NON_PLATED_ICON_MAP[eventDescription]];

  return (
    <Image
      accessibilityIgnoresInvertColors
      source={iconPath}
      style={{ height: Theme.px(height), width: Theme.px(width) }}
    />
  );
};

type TWCAlertIconProps = {
  eventDescription: keyof typeof ALERTS_NON_PLATED_ICON_MAP;
  height?: number;
  width?: number;
};
